import React from "react";
import { Grid } from "@mui/material";

import "../../styles.scss";

export default function SectionFullWidthContainer({
  hasAdditionalTopMargin,
  children,
}: {
  hasAdditionalTopMargin?: boolean;
  children: React.ReactNode;
}): React.JSX.Element {
  const className = hasAdditionalTopMargin ? "scd-section-pusher-lg" : "";
  return (
    <Grid container size={{ xs: 12, md: 12, lg: 12 }} className={className}>
      {children}
    </Grid>
  );
}
